import styled from 'styled-components';
import { ApModal, colors } from '@alixpartners/ui-components';

interface IRadioProps {
  disabled?: boolean;
}

export const StyledModal = styled(ApModal)`
  .ap-modal-wrapper {
    overflow: hidden;
  }

  .ap-modal-content {
    max-width: 560px;
    max-height: 100%;
  }

  .ap-modal-header {
    border: none;
    padding: 8px 16px 16px 32px;

    h4 {
      font-weight: 500;
      font-size: 23px;
      line-height: 31px;
      letter-spacing: 0.3px;
      padding-top: 24px;
      padding-right: 8px;
    }

    .ap-button-icon {
      align-self: flex-start;
    }
  }

  .ap-modal-body {
    padding: 16px 32px 0 32px;
    line-height: 24px;
    display: flex;
    flex-direction: column;
    overflow: scroll;
    letter-spacing: 0.3px;
  }

  .ap-modal-footer {
    padding: 8px 32px;
  }
`;

export const WarningArea = styled.div`
  background-color: rgba(238, 58, 54, 0.1);
  color: ${colors.red2};
  margin: 24px -32px 24px -32px;
  padding: 24px 32px;
`;

export const TextWarning = styled.div`
  color: ${colors.amber};
  font-size: 13px;
  letter-spacing: 0.3px;
  margin-left: 16px;
`;

export const RadioList = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
`;

export const RadioLabel = styled.div<IRadioProps>`
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.3px;
  padding-left: 8px;
  color: ${({ disabled }) => (disabled ? colors.grey5 : colors.grey8)};
`;

export const RadioWrapper = styled.div`
  padding: 10px 0px;
  padding-left: 10px;
`;
